import { useCallback } from 'react'
import type { Dispatch } from 'react'
import { forgotPassword } from '../../../customerAuthApi'
import { asAuthErrorMessage } from '../../../helpers/errors'
import { EMAIL_REGEX } from '../../../hooks/customer-auth-form/validation.constants'
import type { ForgotPasswordFlowAction } from './ForgotPasswordFlow.types'

type UseForgotPasswordSubmitHandlersInput = {
  dispatch: Dispatch<ForgotPasswordFlowAction>
  email: string
}

type UseForgotPasswordSubmitHandlersOutput = {
  handleSubmit: () => Promise<void>
}

export const useForgotPasswordSubmitHandlers = ({
  dispatch,
  email,
}: UseForgotPasswordSubmitHandlersInput): UseForgotPasswordSubmitHandlersOutput => {
  const handleSubmit = useCallback(async () => {
    dispatch({ type: 'SET_EMAIL_TOUCHED', value: true })
    dispatch({ type: 'SET_ERROR', value: '' })

    const normalizedEmail = email.trim()
    if (!normalizedEmail || !EMAIL_REGEX.test(normalizedEmail)) {
      return
    }

    dispatch({ type: 'SET_SUBMITTING', value: true })
    try {
      await forgotPassword(normalizedEmail)
      dispatch({ type: 'SET_SUCCESS', value: true })
    } catch (submitError) {
      dispatch({ type: 'SET_ERROR', value: asAuthErrorMessage(submitError) })
    } finally {
      dispatch({ type: 'SET_SUBMITTING', value: false })
    }
  }, [dispatch, email])

  return { handleSubmit }
}
